import React, { PropsWithChildren, ReactNode } from 'react';

import Box from './Box/Box';

export type CTAaddOnWrapper = PropsWithChildren<{
  ctaAddon?: ReactNode;
  isFloatingLabel?: boolean;
}>;

const CTAaddOnWrapper: React.FC<CTAaddOnWrapper> = props => {
  const { children, ctaAddon, isFloatingLabel = false } = props;
  return (
    <Box display='flex' flexDirection='column' position='relative'>
      {React.isValidElement(ctaAddon) ? (
        <Box alignSelf='flex-end' position={isFloatingLabel ? 'relative' : 'absolute'}>
          {ctaAddon}
        </Box>
      ) : null}
      {children}
    </Box>
  );
};

export default CTAaddOnWrapper;
